// extracted by mini-css-extract-plugin
module.exports = {"catalog":"ObjectsMapCatalogMobile_catalog__9SD_F","catalogHeader":"ObjectsMapCatalogMobile_catalogHeader__egVZL"};